import Icon from '../../Icon';
import { media } from '../../../styles/media';
import styled from 'styled-components';

export const Root = styled.div`
  position: absolute;
  ${props => (props.readOnly ? 'top: 15px;' : 'top: -15px;')} left: 30px;
`;

export const Button = styled.button`
  color: ${props => props.theme.color.brand.white};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: ${props => props.theme.layout.gutter / 2}px;
  min-width: ${props => props.theme.layout.gutter * 3}px;
  height: ${props => props.theme.layout.gutter * 2}px;

  font-family: ${props => props.theme.font.brand.primary};
  font-size: 14px;
  line-height: 19.6px;
  font-weight: 700;

  background: #d9dcde;
  border: none;
  cursor: pointer;
  outline: none;
`;

export const ActiveButton = styled(Button)`
  color: ${props => props.theme.color.brand.white};
  background-color: ${props => props.theme.color.brand.accent};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export const Container = styled.div`
  display: flex;
  padding: ${props => props.theme.layout.gutter / 2}px 0;
  flex-direction: row;
  justify-content: center;
`;

export const IconWrapper = styled.span`
  display: inline-block;
  margin: 0 ${props => props.theme.layout.gutter / 2}px 0 0;
  width: 30px;
  height: 30px;
  font-size: 13px;
  line-height: 30px;
  text-align: center;
  background-color: ${props => props.theme.color.white};
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.07);

  ${media.desktop`
    width: 35px;
    height: 35px;
    font-size: 16px;
    line-height: 35px;
  `};
`;

export const PositionIcon = styled(Icon)`
  display: inline-block;
  text-align: center;
  vertical-align: middle;
`;
